import './signupPage.scss';

import SignupForm from '../UserRegistration/UserRegistaration';

const SignupPage = () => {
  return (
    <div className="signup-page">
      <SignupForm />
    </div>
  );
};

export default SignupPage;
